import { render, staticRenderFns } from "./addFriends.vue?vue&type=template&id=b0dc5628&"
import script from "./addFriends.vue?vue&type=script&lang=js&"
export * from "./addFriends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0dc5628')) {
      api.createRecord('b0dc5628', component.options)
    } else {
      api.reload('b0dc5628', component.options)
    }
    module.hot.accept("./addFriends.vue?vue&type=template&id=b0dc5628&", function () {
      api.rerender('b0dc5628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/code/addFriends.vue"
export default component.exports